import { I18n } from "utils/i18n-shim"

export const getErrorText = (fieldError) => {
  return fieldError instanceof Object
    ? I18n.t(`errors.${fieldError[Object.keys(fieldError)[0]]}`)
    : I18n.t(`errors.${fieldError}`)
}
